// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Ftypes-core%2Fsrc%2Fapology.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { WorkflowExecutionErrorCode, WorkflowNotActivatedReasonCode } from '../../apology';
import { Apology, AuthTokenIsMissingDetails, NotActivatedWorkflowApology, SecondaryApology, WorkflowActivationFailureDetails } from '../apology.g';
import { itemReferenceValidatorInstance } from '../../generated/validator/operations-validator.g';
import { annotationMetaDataValidatorInstance } from '../../generated/validator/annotations-validator.g';
import { schemaObjectHeaderValidatorInstance } from '../../generated/validator/schema-object-validator.g';
import { validateArray } from '@augloop/validator-common';
export class ApologyValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'Apology: Expected object, got undefined object for ApologyValidator' };
        }
        if (obj.annotationTypeName === undefined) {
            return { success: false, error: 'Apology: Required field "annotationTypeName" is missing' };
        }
        else if (typeof obj.annotationTypeName !== 'string') {
            return { success: false, error: 'Apology: Required field "annotationTypeName" is wrong type' };
        }
        if ((obj.scopeItemReference !== undefined)) {
            const result = itemReferenceValidatorInstance.validate(obj.scopeItemReference);
            if (!result.success) {
                result.error = "Apology.scopeItemReference: " + result.error;
                return result;
            }
        }
        if (obj.errorCode === undefined) {
            return { success: false, error: 'Apology: Required field "errorCode" is missing' };
        }
        else {
            const result = workflowExecutionErrorCodeValidatorInstance.validate(obj.errorCode);
            if (!result.success) {
                result.error = "Apology.errorCode: " + result.error;
                return result;
            }
        }
        if (obj.consecutiveFailuresCount === undefined) {
            return { success: false, error: 'Apology: Required field "consecutiveFailuresCount" is missing' };
        }
        else if (typeof obj.consecutiveFailuresCount !== 'number') {
            return { success: false, error: 'Apology: Required field "consecutiveFailuresCount" is wrong type' };
        }
        if ((obj.id !== undefined) && (typeof obj.id !== 'string')) {
            return { success: false, error: 'Apology: Optional field "id" is wrong type' };
        }
        if ((obj.ownerId !== undefined) && (typeof obj.ownerId !== 'string')) {
            return { success: false, error: 'Apology: Optional field "ownerId" is wrong type' };
        }
        if ((obj.invalidationHash !== undefined) && (typeof obj.invalidationHash !== 'string')) {
            return { success: false, error: 'Apology: Optional field "invalidationHash" is wrong type' };
        }
        if ((obj.M_ !== undefined)) {
            const result = annotationMetaDataValidatorInstance.validate(obj.M_);
            if (!result.success) {
                result.error = "Apology.M_: " + result.error;
                return result;
            }
        }
        if ((obj.metadata !== undefined)) {
            const result = annotationMetaDataValidatorInstance.validate(obj.metadata);
            if (!result.success) {
                result.error = "Apology.metadata: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!Apology.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "Apology"' };
        }
        return { success: true };
    }
}
export const apologyValidatorInstance = new ApologyValidator();
export class SecondaryApologyValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SecondaryApology: Expected object, got undefined object for SecondaryApologyValidator' };
        }
        if (obj.originalOwnerId === undefined) {
            return { success: false, error: 'SecondaryApology: Required field "originalOwnerId" is missing' };
        }
        else if (typeof obj.originalOwnerId !== 'string') {
            return { success: false, error: 'SecondaryApology: Required field "originalOwnerId" is wrong type' };
        }
        if (obj.originalScopeItemReference === undefined) {
            return { success: false, error: 'SecondaryApology: Required field "originalScopeItemReference" is missing' };
        }
        else {
            const result = itemReferenceValidatorInstance.validate(obj.originalScopeItemReference);
            if (!result.success) {
                result.error = "SecondaryApology.originalScopeItemReference: " + result.error;
                return result;
            }
        }
        if (obj.annotationTypeName === undefined) {
            return { success: false, error: 'SecondaryApology: Required field "annotationTypeName" is missing' };
        }
        else if (typeof obj.annotationTypeName !== 'string') {
            return { success: false, error: 'SecondaryApology: Required field "annotationTypeName" is wrong type' };
        }
        if ((obj.scopeItemReference !== undefined)) {
            const result = itemReferenceValidatorInstance.validate(obj.scopeItemReference);
            if (!result.success) {
                result.error = "SecondaryApology.scopeItemReference: " + result.error;
                return result;
            }
        }
        if (obj.errorCode === undefined) {
            return { success: false, error: 'SecondaryApology: Required field "errorCode" is missing' };
        }
        else {
            const result = workflowExecutionErrorCodeValidatorInstance.validate(obj.errorCode);
            if (!result.success) {
                result.error = "SecondaryApology.errorCode: " + result.error;
                return result;
            }
        }
        if (obj.consecutiveFailuresCount === undefined) {
            return { success: false, error: 'SecondaryApology: Required field "consecutiveFailuresCount" is missing' };
        }
        else if (typeof obj.consecutiveFailuresCount !== 'number') {
            return { success: false, error: 'SecondaryApology: Required field "consecutiveFailuresCount" is wrong type' };
        }
        if ((obj.id !== undefined) && (typeof obj.id !== 'string')) {
            return { success: false, error: 'SecondaryApology: Optional field "id" is wrong type' };
        }
        if ((obj.ownerId !== undefined) && (typeof obj.ownerId !== 'string')) {
            return { success: false, error: 'SecondaryApology: Optional field "ownerId" is wrong type' };
        }
        if ((obj.invalidationHash !== undefined) && (typeof obj.invalidationHash !== 'string')) {
            return { success: false, error: 'SecondaryApology: Optional field "invalidationHash" is wrong type' };
        }
        if ((obj.M_ !== undefined)) {
            const result = annotationMetaDataValidatorInstance.validate(obj.M_);
            if (!result.success) {
                result.error = "SecondaryApology.M_: " + result.error;
                return result;
            }
        }
        if ((obj.metadata !== undefined)) {
            const result = annotationMetaDataValidatorInstance.validate(obj.metadata);
            if (!result.success) {
                result.error = "SecondaryApology.metadata: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SecondaryApology.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SecondaryApology"' };
        }
        return { success: true };
    }
}
export const secondaryApologyValidatorInstance = new SecondaryApologyValidator();
export class WorkflowActivationFailureReasonValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'WorkflowActivationFailureReason: Expected object, got undefined object for WorkflowActivationFailureReasonValidator' };
        }
        if (obj.code === undefined) {
            return { success: false, error: 'WorkflowActivationFailureReason: Required field "code" is missing' };
        }
        else {
            const result = workflowNotActivatedReasonCodeValidatorInstance.validate(obj.code);
            if (!result.success) {
                result.error = "WorkflowActivationFailureReason.code: " + result.error;
                return result;
            }
        }
        if ((obj.details !== undefined)) {
            const result = workflowActivationFailureDetailsValidatorInstance.validate(obj.details);
            if (!result.success) {
                result.error = "WorkflowActivationFailureReason.details: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const workflowActivationFailureReasonValidatorInstance = new WorkflowActivationFailureReasonValidator();
export class WorkflowActivationFailureDetailsValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'WorkflowActivationFailureDetails: Expected object, got undefined object for WorkflowActivationFailureDetailsValidator' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!WorkflowActivationFailureDetails.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "WorkflowActivationFailureDetails"' };
        }
        return { success: true };
    }
}
export const workflowActivationFailureDetailsValidatorInstance = new WorkflowActivationFailureDetailsValidator();
export class AuthTokenIsMissingDetailsValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AuthTokenIsMissingDetails: Expected object, got undefined object for AuthTokenIsMissingDetailsValidator' };
        }
        if (obj.tokenTypes === undefined) {
            return { success: false, error: 'AuthTokenIsMissingDetails: Required field "tokenTypes" is missing' };
        }
        else {
            const result = validateArray(obj.tokenTypes, 1, undefined, 'number');
            if (!result.success) {
                result.error = "AuthTokenIsMissingDetails.tokenTypes: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!AuthTokenIsMissingDetails.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "AuthTokenIsMissingDetails"' };
        }
        return { success: true };
    }
}
export const authTokenIsMissingDetailsValidatorInstance = new AuthTokenIsMissingDetailsValidator();
export class NotActivatedWorkflowApologyValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'NotActivatedWorkflowApology: Expected object, got undefined object for NotActivatedWorkflowApologyValidator' };
        }
        if (obj.reasons === undefined) {
            return { success: false, error: 'NotActivatedWorkflowApology: Required field "reasons" is missing' };
        }
        else {
            const result = validateArray(obj.reasons, 1, workflowActivationFailureReasonValidatorInstance, '{WorkflowActivationFailureReason}');
            if (!result.success) {
                result.error = "NotActivatedWorkflowApology.reasons: " + result.error;
                return result;
            }
        }
        if (obj.signalPath === undefined) {
            return { success: false, error: 'NotActivatedWorkflowApology: Required field "signalPath" is missing' };
        }
        else {
            const result = validateArray(obj.signalPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "NotActivatedWorkflowApology.signalPath: " + result.error;
                return result;
            }
        }
        if (obj.annotationTypeName === undefined) {
            return { success: false, error: 'NotActivatedWorkflowApology: Required field "annotationTypeName" is missing' };
        }
        else if (typeof obj.annotationTypeName !== 'string') {
            return { success: false, error: 'NotActivatedWorkflowApology: Required field "annotationTypeName" is wrong type' };
        }
        if ((obj.scopeItemReference !== undefined)) {
            const result = itemReferenceValidatorInstance.validate(obj.scopeItemReference);
            if (!result.success) {
                result.error = "NotActivatedWorkflowApology.scopeItemReference: " + result.error;
                return result;
            }
        }
        if (obj.errorCode === undefined) {
            return { success: false, error: 'NotActivatedWorkflowApology: Required field "errorCode" is missing' };
        }
        else {
            const result = workflowExecutionErrorCodeValidatorInstance.validate(obj.errorCode);
            if (!result.success) {
                result.error = "NotActivatedWorkflowApology.errorCode: " + result.error;
                return result;
            }
        }
        if (obj.consecutiveFailuresCount === undefined) {
            return { success: false, error: 'NotActivatedWorkflowApology: Required field "consecutiveFailuresCount" is missing' };
        }
        else if (typeof obj.consecutiveFailuresCount !== 'number') {
            return { success: false, error: 'NotActivatedWorkflowApology: Required field "consecutiveFailuresCount" is wrong type' };
        }
        if ((obj.id !== undefined) && (typeof obj.id !== 'string')) {
            return { success: false, error: 'NotActivatedWorkflowApology: Optional field "id" is wrong type' };
        }
        if ((obj.ownerId !== undefined) && (typeof obj.ownerId !== 'string')) {
            return { success: false, error: 'NotActivatedWorkflowApology: Optional field "ownerId" is wrong type' };
        }
        if ((obj.invalidationHash !== undefined) && (typeof obj.invalidationHash !== 'string')) {
            return { success: false, error: 'NotActivatedWorkflowApology: Optional field "invalidationHash" is wrong type' };
        }
        if ((obj.M_ !== undefined)) {
            const result = annotationMetaDataValidatorInstance.validate(obj.M_);
            if (!result.success) {
                result.error = "NotActivatedWorkflowApology.M_: " + result.error;
                return result;
            }
        }
        if ((obj.metadata !== undefined)) {
            const result = annotationMetaDataValidatorInstance.validate(obj.metadata);
            if (!result.success) {
                result.error = "NotActivatedWorkflowApology.metadata: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!NotActivatedWorkflowApology.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "NotActivatedWorkflowApology"' };
        }
        return { success: true };
    }
}
export const notActivatedWorkflowApologyValidatorInstance = new NotActivatedWorkflowApologyValidator();
export class WorkflowExecutionErrorCodeValidator {
    validate(value) {
        if (!WorkflowExecutionErrorCodeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "WorkflowExecutionErrorCode"' };
        }
        return { success: true };
    }
}
WorkflowExecutionErrorCodeValidator.validValues = new Set([WorkflowExecutionErrorCode.LambdaExecutionUnhandledError, WorkflowExecutionErrorCode.LambdaExecutionError, WorkflowExecutionErrorCode.WorkflowExecutionTimeout, WorkflowExecutionErrorCode.NetworkError, WorkflowExecutionErrorCode.SignalNotGotToExecution, WorkflowExecutionErrorCode.RequestTruncated, WorkflowExecutionErrorCode.WorkflowWrongAnnotationType, WorkflowExecutionErrorCode.SequenceOutOfOrder, WorkflowExecutionErrorCode.WorkflowExecutionThrottled, WorkflowExecutionErrorCode.WorkflowExecutionCancelled, WorkflowExecutionErrorCode.NetworkTimeoutOrWorkflowIsBusy, WorkflowExecutionErrorCode.RequiredTokenNotAvailable, WorkflowExecutionErrorCode.InvalidInputQuantityForSingleItemWorkflow, WorkflowExecutionErrorCode.ExceededRequestSizeLimit, WorkflowExecutionErrorCode.UnknownAnnotationParent, WorkflowExecutionErrorCode.AnnotationsNotArray, WorkflowExecutionErrorCode.UnexpectedOutput, WorkflowExecutionErrorCode.MixedOutput, WorkflowExecutionErrorCode.OutputIsNotAnnotation, WorkflowExecutionErrorCode.UnexpectedError, WorkflowExecutionErrorCode.WorkflowNotActivated]);
export const workflowExecutionErrorCodeValidatorInstance = new WorkflowExecutionErrorCodeValidator();
export class WorkflowNotActivatedReasonCodeValidator {
    validate(value) {
        if (!WorkflowNotActivatedReasonCodeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "WorkflowNotActivatedReasonCode"' };
        }
        return { success: true };
    }
}
WorkflowNotActivatedReasonCodeValidator.validValues = new Set([WorkflowNotActivatedReasonCode.Unknown, WorkflowNotActivatedReasonCode.AuthTokenIsMissing, WorkflowNotActivatedReasonCode.UserContextIsMissing, WorkflowNotActivatedReasonCode.SeedingNotCompleted]);
export const workflowNotActivatedReasonCodeValidatorInstance = new WorkflowNotActivatedReasonCodeValidator();
//# sourceMappingURL=apology-validator.g.js.map